import React from 'react'
import { FaYoutube, FaLinkedin, FaTwitter } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { CAREER_EXTERNAL_LINK } from '../../constants';

const SocialContainer = () => {
    return (
        <div className="hidden lg:flex justify-end items-center pb-4 -mb-8 -2xl:mb-4 relative z-50">
            {/* social icons */}
            <div className="flex items-center space-x-4 pt-6">
                <span className="text-xs xl:text-sm 2xl:text-base font-medium uppercase pr-3 text-blue-primary">
                    FOLLOW US ON
                </span>
                <a href="https://twitter.com/CORCYM_OFFICIAL" target="_blank" rel="noreferrer"
                    className="social-link">
                    {/* <FaTwitter /> */}
                    <img src="/images/footer/twitter_blue.png" alt="twitter_logo" className='w-7 h-7 cursor-pointer transform hover:scale-110' />
                </a>
                <a href="https://www.linkedin.com/company/corcym" target="_blank" rel="noreferrer"
                    className="social-link">
                    {/* <FaLinkedin /> */}
                    <img src="/images/footer/linkdIn_blue.png" alt="linkdIn_logo" className='w-7 h-7 cursor-pointer transform hover:scale-110' />
                </a>
                <a href="https://www.youtube.com/channel/UCem2dzdF2kzV-gL0plAHVEA" target="_blank" rel="noreferrer"
                    className="social-link">
                    {/* <FaYoutube /> */}
                    <img src="/images/footer/youtube_blue.png" alt="youtube_logo" className='w-7 h-7 cursor-pointer transform hover:scale-110' />
                </a>
                <a href="https://www.facebook.com/Corcym" target="_blank" rel="noreferrer"
                    className="social-link">
                    {/* <FaYoutube style={{width: "1.5em", height: "1.5em", fill: "white"}}/> */}
                    <img src="/images/footer/facebook_blue.png" alt="facebook_logo" className='w-7 h-7 cursor-pointer transform hover:scale-110' />
                </a>
                <a href="https://www.instagram.com/corcym_official?igsh=bHB6bzBvMzd0cjFn" target="_blank" rel="noreferrer"
                    className="social-link">
                    {/* <FaYoutube style={{width: "1.5em", height: "1.5em", fill: "white"}}/> */}
                    <img src="/images/footer/instagram_blue.png" alt="instagram_logo" className='w-7 h-7 cursor-pointer transform hover:scale-110' />
                </a>
            </div>

            <div className="ml-6 px-5 xl:px-8 pt-6 border-l-2 border-gray-light flex items-end relative">
                {/* <NavLink to="/careers" className="text-xs xl:text-sm 2xl:text-base text-red-primary font-medium uppercase">
                    CAREERS
                </NavLink> */}
                <a href="/media-library" className="text-xs xl:text-sm 2xl:text-base text-blue-primary font-medium uppercase hover:text-red-primary">
                    MEDIA LIBRARY
                </a>
            </div>

            <div className="px-5 xl:px-8 pt-6 border-l-2 border-gray-light flex items-end relative">
                {/* <NavLink to="/careers" className="text-xs xl:text-sm 2xl:text-base text-red-primary font-medium uppercase">
                    CAREERS
                </NavLink> */}
                <a href="/news" className="text-xs xl:text-sm 2xl:text-base text-blue-primary font-medium uppercase hover:text-red-primary">
                    NEWS
                </a>
            </div>

            {/* Career button */}
            <div className="px-5 xl:px-8 pt-6 border-l-2 border-gray-light flex items-end relative">
                {/* <NavLink to="/careers" className="text-xs xl:text-sm 2xl:text-base text-red-primary font-medium uppercase">
                    CAREERS
                </NavLink> */}
                <a href={CAREER_EXTERNAL_LINK} className="text-xs xl:text-sm 2xl:text-base text-red-primary font-medium uppercase">
                    CAREERS
                </a>
            </div>

        </div>
    )
}

export default SocialContainer
